


































































































































import { Component, Inject, Mixins, Prop, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import { LineItem, LineItems, Quotation } from "../../models/ProjectProposal";
import { SimpleCosts, Unimis } from "../../models/Decoding";
import FormHasError from "../private/forms/FormHasError.vue";
import { cloneDeep } from "lodash";

@Component({
    components: {
        FormHasError
    },
    beforeRouteLeave(
        this: ProjectProposalLineItemsQuotationEdit,
        to: Route,
        from: Route,
        next: NavigationGuardNext<Vue>
    ) {
        if (this.quotation) this.isValid = this.quotation.isValid;
        if (this.isValid.length === 0) next();
        else {
            if (this.canEdit && !this.force) this.showErrorContinueModal = true;
            else {
                if (this.lineItem && +this.quotationId < 0) {
                    this.lineItem.quotations = this.lineItem.quotations.filter(
                        i => i.quotation_id !== +this.quotationId
                    );
                } else this.quotation = this.quotationBck;
                next();
            }
        }
    }
})
export default class ProjectProposalLineItemsQuotationEdit extends Mixins(ProjectProposalMixin, Utils) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Prop() itemId!: string;
    @Prop() quotationId!: string;
    @Prop({ required: true }) lineItems!: LineItems;
    isValid: string[] = [];
    showErrorContinueModal = false;
    force = false;

    unimis: Unimis = new Unimis();
    selectedUnimis: string | null = null;
    simpleCosts: SimpleCosts = new SimpleCosts();
    selectedSimpleCosts: string | null = null;
    quotationBck: Quotation | null = null;

    goBack(force = false) {
        this.force = force;
        this.$router.push({ name: "project-proposal-line-items-edit" });
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    get lineItem(): LineItem | null {
        return this.lineItems.lineItems.find(e => e.item_id.toString() === this.itemId.toString()) ?? null;
    }

    get quotation(): Quotation | null {
        if (this.lineItem) {
            return (
                this.lineItem.quotations.find(e => e.quotation_id.toString() === this.quotationId.toString()) ?? null
            );
        }
        return null;
    }

    set quotation(elem: Quotation | null) {
        if (this.lineItem && elem) {
            this.lineItem.quotations = this.lineItem.quotations.filter(
                e => e.quotation_id.toString() !== this.quotationId
            );
            this.lineItem.quotations.push(elem);
        }
    }

    get tot_amount(): number {
        return this.sum([this.quotation?.net_amount || 0, this.quotation?.vat_amount || 0]);
    }

    get isNetAmountDisabled(): boolean {
        return (
            !this.canEdit ||
            (!!this.lineItem?.isSimpleCost &&
                (!this.selectedSimpleCosts || this.quotation?.simple_cost_formula !== null))
        );
    }

    async saveAndGoBack() {
        if (this.quotation) {
            this.isValid = this.quotation.isValid;
            if (this.isValid.length === 0) this.$emit("save");
            else this.toast(this.i18n("form-not-valid").toString(), { type: "error" });
        }
    }

    async created(): Promise<void> {
        if (this.lineItem && this.lineItem?.isSimpleCost && this.lineItem.activity_sub_code) {
            const [data, err] = await this.maltaModule.decodingApi.getSimpleCosts(
                this.subjectId,
                this.applicationId,
                this.lineItem.activity_sub_code
            );
            if (err) {
                this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                this.$router.push({ name: "project-proposal-line-items-edit" });
            }

            if (data) this.simpleCosts = data;
        } else {
            const [data, err] = await this.maltaModule.decodingApi.getUniMis();
            if (err) {
                this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                this.$router.push({ name: "project-proposal-line-items-edit" });
            }

            if (data) this.unimis = data;
        }

        if (this.quotation) {
            this.selectedUnimis = this.quotation.um_sub_code;
            this.selectedSimpleCosts = this.quotation.simple_cost_sub_code;
            this.quotation.touched = true;
            this.quotationBck = cloneDeep(this.quotation);
        }

        if (this.lineItem) {
            this.lineItem.touched = true;
        }
    }

    @Watch("selectedUnimis")
    onChangeSelectedUnimis(): void {
        if (this.quotation) {
            this.quotation.umimis =
                this.unimis.unimis.find(umimi => umimi.unimis_sub_code === this.selectedUnimis) ?? null;
        }
    }

    @Watch("selectedSimpleCosts")
    @Watch("quotation.quantity")
    @Watch("quotation.net_amount")
    onChangeSelectedSimpleCosts(): void {
        if (this.quotation && this.lineItem?.isSimpleCost) {
            this.quotation.simpleCost =
                this.simpleCosts.records.find(
                    simpleCost => simpleCost.simple_cost_sub_code === this.selectedSimpleCosts
                ) ?? null;
        }
    }

    mounted(): void {
        if (this.quotation === null) {
            this.toast(this.i18n("item-not-found").toString(), { type: "error" });
            this.$router.push({ name: "project-proposal-line-items-edit" });
        }
    }

    get currentUnitLabel(): string {
        if (this.lineItem?.isSimpleCost) {
            const unit = this.quotation?.simple_cost_unit ?? "";
            if (unit) return unit;
            const selected = this.simpleCosts?.records?.find(
            r => r.simple_cost_sub_code === this.selectedSimpleCosts
            );
            if (selected?.simple_cost_unit) return selected.simple_cost_unit;

            const only = this.simpleCosts?.records?.length === 1 ? this.simpleCosts.records[0] : null;
            if (only?.simple_cost_unit) return only.simple_cost_unit;

            if (selected?.simple_cost_description) return selected.simple_cost_description;
            if (only?.simple_cost_description) return only.simple_cost_description;

            return "";
        }

        const unit = this.quotation?.um_description ?? "";
        if (unit) return unit;

        const code = this.selectedUnimis || this.quotation?.um_sub_code || "";
        if (code) {
            const um = this.unimis.unimis.find(u => u.unimis_sub_code === code);
            if (um?.unimis_long_description) return um.unimis_long_description;
            if (um?.unimis_description) return um.unimis_description;
        }

        return "";
    }
    get quantityDecimals(): number {
        const u = this.currentUnitLabel.trim().toLowerCase();

        const isHectare =
            u === "ha" ||
            u === "hectare" ||
            u === "hectares" ||
            u.includes("hectare") ||
            u.includes("hectar") ||   
            u.includes("hector"); 

        return isHectare ? 4 : 0;
    }



}
